module.exports = __webpack_public_path__ + "img/20_110.8f3b3bcc.png";